import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';

import type { SpaceSubmitType } from 'app/components/commons/Hotel/Types';
import { apiMutation } from 'app/utils/request/api';

const saveHotelSpacesPath = 'hotels/:hotelId/spaces' as const;

export function useSaveHotelSpaces(
  hotelId: string,
  { showSuccessMessage = true }: { showSuccessMessage?: boolean } = {}
) {
  return useMutation({
    mutationFn: async (payload: SpaceSubmitType) =>
      apiMutation(
        'PUT',
        {
          path: saveHotelSpacesPath,
          params: { hotelId },
        },
        payload
      ) as Promise<void>,
    onSuccess: () => {
      if (showSuccessMessage) {
        message.success('Hotel successfully saved!');
      }
    },
    onError: () => {
      message.error('Error posting Spaces');
    },
  });
}
